import React, { useState, useEffect } from "react"
import ManageUsersInfo from './components/ManageUsersInfo'
import Modal from '../../components/Modal'
import useSWR from 'swr'
import Signup from '../Signup'
import { Group, Search } from '@mui/icons-material'
import { Skeleton, Button, Typography, TextField, InputAdornment } from '@mui/material'
import CreateableAutocompleteDropdown from '../../components/CreateableAutocompleteDropdown'
import styles from './ManageUsersInfo.module.scss'

export default function ContainerManageUsersInfo() {
    const { data } = useSWR(`/api/getUsersInformation`)
    const [rows, setRows] = useState([])
    const [isOpen, setIsOpen] = useState(false)
    const [searchKeyWord, setSearchKeyWord] = useState('')
    const [companyNames, setCompanyNames] = useState([])
    const [company, setCompany] = useState(null)

    useEffect(() => {
        const filter = data ? JSON.parse(data).filter(user => {
            let filterByTextInput = user.name.toLowerCase().includes(searchKeyWord.toLowerCase())
            return filterByTextInput && company ? user.uuid === company.uuid : filterByTextInput
        }) : []
        setRows(filter)
        return () => {}
    }, [searchKeyWord, company, data])

    useEffect(() => {
        fetch(`api/getCompanyNames`)
            .then(res => res.json())
            .then(res => setCompanyNames(res.company))
        return () => {}
    }, [])

    const handleTextField = (e) => setSearchKeyWord(e.target.value)
    
    const handleOpenModal = () => setIsOpen(!isOpen)
    
    return (
        <div className={styles["container-manage-user-info"]}>
            <div className={`${styles["display-flex-row"]} ${styles["display-header-container"]}`}>
                <div className={styles["display-flex-row"]}>
                    <Group fontSize='large'/>
                    <Typography variant="h1">Manage users</Typography>
                </div>
                <Button onClick={handleOpenModal} variant="contained" color="primary">Add new user</Button>
            </div>
            <div className={styles['fields']}>
                <CreateableAutocompleteDropdown size='small' disableCreation={true} dropdownOptions={companyNames} value={company} setValue={setCompany} placeholder="Company name" />
                <TextField
                    variant="outlined"
                    placeholder="Search member's name"
                    className='search-header'
                    size='small'
                    onChange={(e) => handleTextField(e)}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <Search color="textPrimary"/>
                            </InputAdornment>
                        )
                    }}
                />
            </div>
            {data 
                ? <ManageUsersInfo rowData={rows} /> 
                : <Skeleton variant="rect" width='1000px' height='500px' />}
            <Modal open={isOpen} handleClose={handleOpenModal} title="Add a new user">
                <Signup />
            </Modal>
        </div>
    )
}
